import { LoadingScreen } from '@/components/common/LoadingScreen';
import { useAuth } from '@/hooks/useAuth';
import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Gates the backoffice routes to users holding the ADMIN role.
 *
 * This is a UX guard, not a security boundary: it runs client-side and only hides
 * screens. Every backoffice endpoint is enforced server-side with @PreAuthorize.
 */
export const AdminGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isUserReady, hasAdminRole } = useAuth();

  // authStore persists only the tokens, so on a fresh load `user` is null and
  // `isLoadingUser` is still false until the GET /users request starts. That is
  // what `isUserReady` covers, and it is what keeps a hard refresh on /admin/*
  // from bouncing the admin out before their roles are known.
  if (!isUserReady) {
    return <LoadingScreen />;
  }

  if (!hasAdminRole) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
